<template>
  <div class=" bg-base flex flex-col gap-5 rounded-lg border p-10">
    <div class=" flex items-center gap-2  pb-5">
      <button
        :class="!isCompany && 'btn-primary btn-active'"
        class=" btn  btn-wide  "
        @click="isCompany=false"
      >
        Applicant Eligibility
      </button>
      <button
        :class="isCompany && 'btn-primary btn-active'"
        class="btn  btn-wide"
        @click="isCompany=true"
      >
        Companies Eligibility
      </button>
    </div>
    <div v-if="isCompany">
      <BaseTemplate :options="{slug: 'companies-eligibility'}" />
    </div>
    <div v-else>
      <BaseTemplate :options="{slug: 'applicants-eligibility'}" />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import BaseTemplate from './base_template.vue'

const isCompany = ref(true)
</script>